import { render, staticRenderFns } from "./c-welcome-block.vue?vue&type=template&id=108c96cb&"
import script from "./c-welcome-block.vue?vue&type=script&lang=js&"
export * from "./c-welcome-block.vue?vue&type=script&lang=js&"
import style0 from "./c-welcome-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports